import 'regenerator-runtime/runtime';
import Alpine from 'alpinejs';
export var parkMenu = function parkMenu() {
  Alpine.data('parkMenu', function () {
    return {
      init: function init() {
        // eslint-disable-next-line prefer-destructuring
        this.tabListElement = this.$el.querySelectorAll('[x-bind="bindTabList"]')[0];
      },
      tabListScroll: function tabListScroll() {
        var tabListClass = 'a-park-menu__tab-list';
        var maxScrollLeft = this.$el.scrollWidth - this.$el.clientWidth;
        if (this.$el.scrollLeft < 16) {
          this.$el.classList.add("".concat(tabListClass, "--scroll-start"));
        } else {
          this.$el.classList.remove("".concat(tabListClass, "--scroll-start"));
        }
        if (this.$el.scrollLeft > maxScrollLeft - 16) {
          this.$el.classList.add("".concat(tabListClass, "--scroll-end"));
        } else {
          this.$el.classList.remove("".concat(tabListClass, "--scroll-end"));
        }
      },
      bindArrowButton: {
        // eslint-disable-next-line func-names
        '@click': function click() {
          if (this.$el.classList.contains('a-park-menu__arrow-right')) {
            this.tabListElement.scrollLeft += 100;
          } else {
            this.tabListElement.scrollLeft -= 100;
          }
        }
      },
      bindTabList: {
        // eslint-disable-next-line func-names
        '@load.window': function loadWindow() {
          this.tabListScroll();
        },
        // eslint-disable-next-line func-names
        '@scroll': function scroll() {
          this.tabListScroll();
        },
        // eslint-disable-next-line func-names
        '@resize.window.debounce.500ms': function resizeWindowDebounce500ms() {
          this.tabListScroll();
        }
      }
    };
  });
};